(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ark-bed-configurator"] && !Shopify.designMode) return;
  try {
    class ArkBedConfigurator extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.config = JSON.parse(this.querySelector('[data-bed-config]').textContent);
    this.form = this.querySelector('form');
    this.cartCounts = new Map();
    this.busy = false;
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted || !this.isConnected) return;
      if (this.addConfirmed) this.pendingGroup = null;
      this.addConfirmed = false; this.busy = false; this.serverError = false; this.form.inert = false;
      this.readCart().then(() => this.update()).catch(() => this.update());
    });
    this.form.addEventListener('change', (event) => { this.serverError = false; this.update(event.target.name); });
    this.form.addEventListener('input', (event) => { if (event.target.name === 'bed_quantity') this.update(); });
    this.form.addEventListener('submit', (event) => this.submit(event));
    this.update();
    customElements.whenDefined('media-gallery').then(() => { this.update('bed_colour'); this.warmImages(); });
    this.readCart().then(() => this.update()).catch(() => {});
  }

  get root() { return window.Shopify?.routes?.root || '/'; }
  warmImages() {
    if (navigator.connection?.saveData || /^(slow-)?2g$/.test(navigator.connection?.effectiveType || '')) return;
    const section = this.closest('.shopify-section');
    const galleryData = section.querySelector('[data-ark-gallery-data]');
    if (!galleryData) return;
    const config = JSON.parse(galleryData.textContent);
    const template = section.querySelector('media-gallery img');
    const run = async () => {
      for (const id of new Set(Object.values(this.config.images))) {
        if (!this.isConnected) return;
        const media = config.media.find((m) => String(m.id) === id);
        if (!media) continue;
        const url = new URL(media.src, location.href);
        url.searchParams.set('width', String(Math.min(1254, Math.ceil(innerWidth * devicePixelRatio))));
        const image = new Image(); image.fetchPriority = 'low'; image.decoding = 'async';
        if (template?.srcset) {
          image.sizes = template.sizes;
          image.srcset = [...template.srcset.matchAll(/(\d+)w/g)].map((match) => { const candidate = new URL(media.src, location.href); candidate.searchParams.set('width',match[1]); return `${candidate.href} ${match[1]}w`; }).join(', ');
        }
        image.src = url.href;
        await Promise.race([image.decode().catch(() => {}), new Promise((r) => setTimeout(r, 3000))]);
      }
    };
    const schedule = () => window.requestIdleCallback ? window.requestIdleCallback(run) : setTimeout(run, 1000);
    if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule, {once:true});
  }
  selected() {
    const id = Number(this.form.elements.bed_colour.value);
    const cover = this.config.covers.find((v) => v.id === id);
    const extraEnabled = this.form.elements.bed_extra_enabled.checked;
    const extra = extraEnabled ? this.config.covers.find((v) => v.id === Number(this.form.elements.bed_extra.value)) : null;
    const set = this.form.elements.bed_purchase.value === 'set';
    const quantity = Number(this.form.elements.bed_quantity.value);
    return { cover, extra, extraEnabled, set, quantity };
  }

  remaining(variant) {
    if (!variant?.available) return 0;
    return variant.stock === null ? Infinity : Math.max(0, variant.stock - (this.cartCounts.get(variant.id) || 0));
  }

  money(amount) {
    if (this.config.currency === 'SGD') return `S$${(amount / 100).toFixed(2)}`;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.config.currency}).format(amount / 100);
  }

  requestItems(selection) {
    const items = new Map();
    const add = (variant) => { if (variant) items.set(variant.id, (items.get(variant.id) || 0) + selection.quantity); };
    if (selection.set) add(this.config.foam);
    add(selection.cover); add(selection.extra);
    return [...items].map(([id, quantity]) => ({id, quantity}));
  }

  problem(selection) {
    if (!selection.cover || (selection.extraEnabled && !selection.extra)) return this.config.labels.choose;
    if (!Number.isInteger(selection.quantity) || selection.quantity < 1) return this.config.labels.stock;
    const variants = [this.config.foam, ...this.config.covers];
    return this.requestItems(selection).some((item) => this.remaining(variants.find((v) => v.id === item.id)) < item.quantity) ? this.config.labels.stock : '';
  }

  update(source) {
    const s = this.selected();
    const total = ((s.set ? this.config.foam.price : 0) + (s.cover?.price || 0) + (s.extra?.price || 0)) * (s.quantity || 1);
    this.querySelector('.ark-bed-extra').hidden = !s.extraEnabled;
    this.querySelector('[data-bed-total]').textContent = this.money(total);
    const parts = [s.set ? this.config.labels.set : this.config.labels.cover, s.cover?.title];
    if (s.extra) parts.push(`${this.config.labels.extra}: ${s.extra.title}`);
    this.querySelector('[data-bed-summary]').textContent = parts.filter(Boolean).join(' · ');
    for (const price of this.closest('.shopify-section').querySelectorAll('[data-ark-bed-price] .price')) price.textContent = this.money(total / (s.quantity || 1));
    for (const radio of this.querySelectorAll('[name="bed_colour"]')) {
      const variant = this.config.covers.find((v) => v.id === Number(radio.value));
      radio.nextElementSibling.toggleAttribute('data-unavailable', this.remaining(variant) < 1);
    }
    for (const option of this.querySelectorAll('[name="bed_extra"] option[value]')) {
      if (!option.value) continue;
      const variant = this.config.covers.find((v) => v.id === Number(option.value));
      const primary = variant?.id === s.cover?.id ? s.quantity : 0;
      option.disabled = this.remaining(variant) < primary + s.quantity;
    }
    const max = Math.min(this.remaining(s.cover) / (s.extra?.id === s.cover?.id ? 2 : 1), s.set ? this.remaining(this.config.foam) : Infinity, s.extra ? this.remaining(s.extra) : Infinity);
    if (Number.isFinite(max)) this.form.elements.bed_quantity.max = String(Math.max(1, Math.floor(max)));
    else this.form.elements.bed_quantity.removeAttribute('max');
    const error = this.problem(s);
    const button = this.querySelector('[data-bed-add]');
    button.disabled = Boolean(error) || this.busy;
    button.textContent = this.busy ? this.config.labels.adding : this.config.labels.add;
    if (!this.serverError) {
      this.querySelector('[data-bed-error]').textContent = error;
      this.querySelector('[data-bed-error]').hidden = !error;
    }
    if (source?.startsWith('bed_') && source !== 'bed_quantity' && source !== 'bed_purchase') this.showImages(s, source);
  }

  showImages(s, source) {
    const section = this.closest('.shopify-section');
    const gallery = section.querySelector('media-gallery');
    if (!gallery || !s.cover) return;
    const covers = source === 'bed_extra' && s.extra ? [s.extra, s.cover] : [s.cover, s.extra].filter(Boolean);
    const ids = [...new Set(covers.map((v) => this.config.images[v.sku]).filter(Boolean))];
    const missing = !this.config.images[covers[0].sku];
    let placeholder = section.querySelector('[data-bed-missing-gallery]');
    if (!placeholder) {
      placeholder = document.createElement('div'); placeholder.className = 'ark-bed-gallery-missing';
      placeholder.dataset.bedMissingGallery = ''; placeholder.hidden = true;
      gallery.parentElement.append(placeholder);
    }
    gallery.hidden = missing;
    placeholder.hidden = !missing;
    this.querySelector('[data-bed-photo-note]').hidden = !missing;
    if (missing) placeholder.textContent = `${covers[0].title} — ${this.querySelector('[data-bed-photo-note]').textContent}`;
    else {
      this.dispatchEvent(new CustomEvent('ark:gallery-select', {bubbles:true, detail:{productId:String(this.config.productId), ids}}));
      const current = section.querySelector('media-gallery');
      if (current) current.hidden = false;
    }
  }

  async readCart() {
    const response = await fetch(`${this.root}cart.js`, {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    this.cartCounts = new Map();
    for (const item of cart.items) this.cartCounts.set(item.variant_id, (this.cartCounts.get(item.variant_id) || 0) + item.quantity);
    return cart;
  }

  async submit(event) {
    event.preventDefault();
    if (this.busy) return;
    this.busy = true; this.serverError = false;
    this.form.inert = true;
    this.querySelector('[data-bed-review]').hidden = true;
    this.update();
    const s = this.selected();
    try {
      const cart = await this.readCart();
      if (this.pendingGroup && cart.items.some((item) => item.properties?._ark_bed_group === this.pendingGroup)) {
        location.assign(`${this.root}cart`); return;
      }
      const error = this.problem(s);
      if (error) throw new Error(error);
      this.pendingGroup = crypto.randomUUID();
      const items = this.requestItems(s).map((item) => ({...item, properties:{_ark_bed_group:this.pendingGroup}}));
      this.form.inert = true;
      const response = await fetch(`${this.root}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || this.config.labels.failed);
      this.addConfirmed = true;
      location.assign(`${this.root}cart`);
    } catch (error) {
      this.serverError = true;
      this.querySelector('[data-bed-error]').textContent = `${error.message || this.config.labels.failed}`;
      this.querySelector('[data-bed-error]').hidden = false;
      this.querySelector('[data-bed-review]').hidden = false;
      await this.readCart().catch(() => {});
      this.form.inert = false; this.busy = false; this.update();
    }
  }
}
if (!customElements.get('ark-bed-configurator')) customElements.define('ark-bed-configurator', ArkBedConfigurator);
  } catch(e) { console.error(e); }
})();

})();
